import L from 'leaflet';
import 'leaflet.markercluster';
import { createLayerComponent, createElementObject, extendContext } from '@react-leaflet/core';

const createMarkerCluster = (props, context) => {
  const { children: _children, ...options } = props;
  const instance = L.markerClusterGroup(options);

  return createElementObject(instance, extendContext(context, { layerContainer: instance }));
};

export const ClusterGroup = createLayerComponent(createMarkerCluster);
